import cls from './NavMenu.module.scss'
import { NavButton } from 'shared/ui/NavButton'
import {
    AddCircleIcon,
    FriendsIcon,
    HomeIcon,
    ProfileIcon,
} from 'shared/ui/Icon'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { navActions } from '../model/slice/navSlice'
import React from 'react'

const hasRouteValue = (value) =>
    value !== undefined && value !== null && String(value).trim() !== ''

export const getProfilePath = (nickname, id) => {
    if (hasRouteValue(nickname)) return `/${nickname}`
    if (hasRouteValue(id)) return `/${id}`
    return '/'
}

export const NavMenu = () => {
    const location = useLocation()
    const dispatch = useDispatch()
    const newContent = useSelector((state) => state.nav.newContent)
    const id = useSelector((state) => state.auth.id)
    const nickname = useSelector((state) => state.auth.nickname)

    const onActive = () => {
        dispatch(navActions.onActive(location.pathname))
        dispatch(navActions.setNewContent(false))
    }

    return (
        <div className={cls.Navbar}>
            <NavButton
                to="/"
                title={'Мечты'}
                location={location}
                icon={HomeIcon}
            />
            <NavButton
                to="/suggest"
                title={'Создать'}
                location={location}
                icon={AddCircleIcon}
            />
            <NavButton
                to="/friends"
                title={'Друзья'}
                location={location}
                icon={FriendsIcon}
            />
            <NavButton
                to={getProfilePath(nickname, id)}
                title={'Профиль'}
                location={location}
                icon={ProfileIcon}
                newContent={newContent}
                onActive={onActive}
            />
        </div>
    )
}
